export const PersonnelVI = {
    "contractType": "Loại hợp đồng",
    "rewardWelfare": "Khen thưởng/phúc lợi",
    "jobPosition": "Cài đặt vị trí công việc",
    "jobTitle": "Cài đặt chức vụ",
    "workLocation": "Cài đặt nơi làm việc",
    "companyRules": "Cài đặt quy định phạt",
    "allowancesType": "Quản lý phụ cấp",
    "levelAndPayGrade": "Cài đặt ngạch lương",
    "category": "Danh mục",
    "employeeType": "Hình thức làm việc",
    "reward": "Khen thưởng",
    "discipline": "Kỷ luật",
    "appointment": "Tiếp nhận",
    "dropWork": "Thôi việc"
}